import { render, staticRenderFns } from "./SurveyFormImage.vue?vue&type=template&id=70fd6889&"
import script from "./SurveyFormImage.vue?vue&type=script&lang=js&"
export * from "./SurveyFormImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports